import Container from '@material-ui/core/Container';
import React from 'react';
import { useIntl } from 'react-intl';
import { LabsMap, labsMapStyles } from '../components/LabsMap';
import { googleMapsURL } from '../config';
import { Page } from '../types';
import { BoxContainer } from './Landing';

export const CheckupLabs: Page = () => {
  const { landingContainer, loading, map } = labsMapStyles();
  const isPrerender = navigator.userAgent === 'ReactSnap';
  const intl = useIntl();

  return (
    <BoxContainer>
      {!isPrerender && (
        <Container>
          <LabsMap
            googleMapURL={googleMapsURL}
            containerElement={<div className={landingContainer} />}
            loadingElement={<div className={loading} />}
            mapElement={<div className={map} />}
            gotoLabText={intl.messages['goto_lab']?.toString() || 'goto_lab'}
          />
        </Container>
      )}
    </BoxContainer>
  );
};

CheckupLabs.page = 'checkup-labs';
